import * as colors from "../../styles/colors";
import appStyles from "../../styles/appStyles";
import IconButton from "../IconButton";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import StyledXIcon from "../StyledXIcon";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	container: {
		display: "flex",
		padding: "0px 0px 0px 16px",
		backgroundColor: colors.docketLightGrey3,
		alignItems: "center",
	},
	title: {
		flexGrow: 1,
		flexShrink: 1,
		flexBasis: "auto",
		color: colors.black,
	},
	titleWithIcon: {
		marginLeft: 8,
	},
	iconButton: {
		fill: colors.textDarkGrey2,
	},
});

export default class DialogHeader extends PureComponent {
	static propTypes = {
		handleClose: PropTypes.func,
		closeDisabled: PropTypes.bool.isRequired,
		icon: PropTypes.node,
		title: PropTypes.string.isRequired,
	};

	static defaultProps = {
		closeDisabled: false,
	};

	_renderClose = () => (
		<IconButton
			visualHover={!this.props.closeDisabled}
			onClick={!this.props.closeDisabled ? this.props.handleClose : null}
		>
			<StyledXIcon aStyles={styles.iconButton} />
		</IconButton>
	);

	render() {
		return (
			<div className={css(styles.container)}>
				{this.props.icon}
				<h2
					className={css(
						appStyles.baseFont,
						styles.title,
						this.props.icon ? styles.titleWithIcon : null,
					)}
				>
					{this.props.title}
				</h2>
				{this.props.handleClose ? this._renderClose() : null}
			</div>
		);
	}
}
